import { useOverlays } from "contexts/OverlayContext";
import { PlainModal } from "@design-system/Modal/Modal";
import { CreateDocumentCategoryModal } from "./CreateDocumentCategoryModal";

export const CreateDocumentCategoryModalContainer = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("createDocumentCategory");

    if (!overlayInfo?.data) {
        return null;
    }

    const { parentCategoryId, categoryName, onCategoryCreated } =
        overlayInfo.data;

    return (
        <PlainModal show={!overlayIsClosing} onHide={closeOverlay}>
            <CreateDocumentCategoryModal
                parentCategoryId={parentCategoryId}
                categoryName={categoryName}
                onCategoryCreated={onCategoryCreated}
                onHide={closeOverlay}
            />
        </PlainModal>
    );
};
